import { post, postExFile } from "@utils/httpUtil";
// 分页查询题库列表
export function questionBankGetPageInfo(data, config) {
  return post(`/c/pc/community/question/bank/getPage`, data, config);
}
// 题库管理-新增/跟新题目
export function questionBankSave(data, config) {
  return post(`/c/pc/community/question/bank/save`, data, config);
}
// 题库管理-删除题目
export function questionBankDelete(data, config) {
  return post(`/c/pc/community/question/bank/delete`, data, config);
}
// 题库管理-题目详情
export function questionBankGetDetail(data, config) {
  return post(`/c/pc/community/question/bank/getDetail`, data, config);
}
// 问卷模板-根据条件查询数据分页
export function questionnaireTemplateGetPageInfo(data, config) {
  return post(`/c/pc/community/questionnaire/template/getPageInfo`, data, config);
}
// 问卷模板-问卷模板标题校验
export function questionnaireTemplateCheckTitleUnique(data, config) {
  return post(`/c/pc/community/questionnaire/template/checkTitleUnique`, data, config);
}
// 问卷模板-问卷模板保存
export function questionnaireTemplateSave(data, config) {
  return post(`/c/pc/community/questionnaire/template/save`, data, config);
}
// 问卷模板-问卷模板详情
export function questionnaireTemplateGetDetail(data, config) {
  return post(`/c/pc/community/questionnaire/template/getDetail`, data, config);
}
// 问卷模板-问卷模板删除
export function questionnaireTemplateDelete(data, config) {
  return post(`/c/pc/community/questionnaire/template/delete`, data, config);
}
// 问卷模板-新建/更新问卷
export function saveQuestionnaire(data, config) {
  return post(`/c/pc/community/questionnaire/saveQuestionnaire`, data, config);
}
// 问卷模板-获取问卷详情
export function questionnaireGetDetailById(data, config) {
  return post(`/c/pc/community/questionnaire/getDetailById`, data, config);
}
// 问卷模板-问卷生成模板
export function questionnaireGenerationTemplate(data, config) {
  return post(`/c/pc/community/questionnaire/questionnaireGenerationTemplate`, data, config);
}
// 问卷模板-获取问卷详情
export function questionnaireCopyQuestionnaire(data, config) {
  return post(`/c/pc/community/questionnaire/copyQuestionnaire`, data, config);
}
// Saas-ICD-10 标签列表
export function questionnaireDiseaseLabelPage(data, config) {
  return post(`/c/pc/community/questionnaire/diseaseLabelPage`, data, config);
}
// 问卷-问卷转ppt新增数据
export function questionnaireSavePptConfig(data, config) {
  return post(`/c/pc/community/questionnaire/savePptConfig`, data, config);
}
// 问卷-获取问卷转ppt数据
export function questionnairePptConfigDetail(data, config) {
  return post(`/c/pc/community/questionnaire/pptConfigDetailByQuestionnaireId`, data, config);
}
// Saas-排重分类列表分页
export function findActivityCommonSettingPage(data, config) {
  return post(`/c/pc/sp/activity/findActivityCommonSettingPage`, data, config);
}
// Saas-查询问卷id列表
export function findTaskFormActivityPage(data, config) {
  return post(`/c/pc/sp/activity/findTaskFormActivityPage`, data, config);
}
// Saas-批量添加问卷id
export function batchBindBusinessIdAndRepeatedClassId(data, config) {
  return post(`/c/pc/sp/activity/batchBindBusinessIdAndRepeatedClassId`, data, config);
}
// Saas-删除绑定的问卷id
export function deleteBusinessIdAndRepeatedClassId(data, config) {
  return post(`/c/pc/sp/activity/deleteBusinessIdAndRepeatedClassId`, data, config);
}
// Saas-批量应用模板
export function batchApplyTemplate(data, config) {
  return post(`/c/pc/community/questionnaire/template/batchApplyTemplate`, data, config);
}
// Saas-批量应用模板-下载错误文件
export function batchApplyTemplateFailExport(data, config) {
  return postExFile(`/c/pc/community/questionnaire/template/batchApplyTemplate/failExport`, data, config);
}